import { AttachFilesForClientCardComponent } from '@app/components/AttachFilesForClientCardComponent/AttachFilesForClientCardComponent.main';

export { AttachFilesForClientCardComponent };
